// Thin PostHog wrapper. Every helper is a no-op when REACT_APP_POSTHOG_KEY
// is not set, so local/dev builds don't leak events and CI stays clean.
import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

let initialized = false;

export function initAnalytics() {
  if (initialized || !KEY) return;
  posthog.init(KEY, {
    api_host: HOST,
    // Automatic pageviews cover most tabs; we still call capture on route
    // changes below to guarantee SPA transitions are recorded.
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    person_profiles: "identified_only",
    loaded: (ph) => {
      if (process.env.NODE_ENV === "development") ph.debug(false);
      // Expose for browser devtools debugging so users/testers can inspect
      // window.posthog and confirm events fire.
      if (typeof window !== "undefined") window.posthog = ph;
      // Fire an explicit initial pageview so PostHog sees traffic on load
      // even before autocapture registers any DOM interactions.
      ph.capture("$pageview", { $current_url: window.location.href });
    },
  });
  initialized = true;
}

export function identifyUser(user) {
  if (!KEY || !user) return;
  posthog.identify(user.id, {
    email: user.email,
    name: user.full_name,
    role: user.role,
    // eslint-disable-next-line camelcase
    onboarding_completed: !!user.onboarding_completed,
  });
}

export function resetAnalytics() {
  if (!KEY) return;
  posthog.reset();
}

// Named events for the parts of the app we most want to watch during beta.
export function track(event, props) {
  if (!KEY) return;
  posthog.capture(event, props || {});
}

// Manual pageview — useful for route changes on SPAs.
export function trackPageview(pathname) {
  if (!KEY) return;
  posthog.capture("$pageview", { $current_url: window.location.href, path: pathname });
}
